import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { OrderReturnItem, OrderReturnItemCreate, OrderReturnItemFilter } from '../data/orderReturnItem';

export function createOrderReturnItemService(client: AxiosInstance) {
  return createCrudService<OrderReturnItem, OrderReturnItemCreate, OrderReturnItemFilter>(
    client,
    '/OrderReturnItem',
    'orderReturnItemId'
  );
}

export type OrderReturnItemService = CrudService<
  OrderReturnItem,
  OrderReturnItemCreate,
  OrderReturnItemFilter
>;
